import { IconButton, InputAdornment, TextField } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import ClearIcon from '@mui/icons-material/Clear';

interface CustomDatePickerProps {
  label: string;
  value: Date | null;
  onChange: (date: Date | null) => void;
}
export const CustomDatePicker = ({ label, value, onChange }: CustomDatePickerProps) => (
  <DatePicker
    label={label}
    value={value}
    onChange={(newValue) => onChange(newValue)}
    renderInput={(params) => (
      <TextField
        size="small"
        sx={{ minWidth: 200 }}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...params}
        InputProps={{
          endAdornment: (
            <>
              {value && (
                <InputAdornment position="end">
                  <IconButton onClick={() => onChange(null)} edge="end">
                    <ClearIcon />
                  </IconButton>
                </InputAdornment>
              )}
              {params.InputProps?.endAdornment}
            </>
          ),
        }}
      />
    )}
  />
);
